import axiosInstance from "../utils/axios";
export const getSiteSettings = async() =>{
    try {
        const response = await axiosInstance.get('/api/site-settings')
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateSiteSettings = async (showDevBanner, devBannerMessage) => {
  try {
    const response = await axiosInstance.put('/api/site-settings', {
      showDevBanner,
      devBannerMessage
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};